import request from '@/utils/request'
const url = 'admin/Chart'
const api = {
  // 获取用户趋势
  getUserChats(data) {
    return request({
      url: `${url}/getUserChats`,
      method: 'post',
      data
    })
  },
  // 获取预约趋势
  getReservationChats(data) {
    return request({
      url: `${url}/getReservationChats`,
      method: 'post',
      data
    })
  },
  // 获取订单趋势
  getOrderChats(data) {
    return request({
      url: `${url}/getOrderChats`,
      method: 'post',
      data
    })
  }
}

export default api
